import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'octali-lib-firebase-utils';
import { DisplayerService } from 'octali-lib-utils';

@Component({
  selector: 'app-login-view',
  templateUrl: './login-view.component.html',
  styleUrls: ['./login-view.component.scss'],
})
export class LoginViewComponent implements OnInit {

  @Output() signup: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() login: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() resetPassword: EventEmitter<boolean> = new EventEmitter<boolean>();

  public loginForm: FormGroup;

  constructor(
    private profileService: UserService,
    private displayer:DisplayerService,
    private formBuilder: FormBuilder
  ) { 
    this.loginForm = formBuilder.group({
      email: [ '', Validators.required ],
      password: [ '', Validators.compose([Validators.minLength(6), Validators.required ])
    ]});
  }

  ngOnInit() {
  }
 

  async goLogin(loginForm: FormGroup): Promise<void> {
    if (!loginForm.valid) {
      console.log(loginForm.value);
    } else {
      await this.displayer.presentLoader();
      this.profileService.login(loginForm.value.email,loginForm.value.password).then(
        async userCredential => {
          await this.displayer.dismissLoader();
          this.login.next( true );
        }, async error => {
          await this.displayer.dismissLoader();
          await this.displayer.presentAlert("Erreur de connexion","",error.message);
          this.login.next( false );
        });
    }
  }

  goSignup() {
    //this.displayer.presentModal(SignupPage);
    this.signup.emit( true );
  }

  goReset() {
    this.resetPassword.next( true );
  }
}
